/**
 * /settings landing page.
 *
 * Renders the settings hub on every width: a search box and the existing
 * settings pages grouped into a short list (see SettingsHub / settingsHubIndex).
 * Previously this redirected desktop users straight to the first tab and
 * showed a flat card list on mobile.
 */
import SettingsHub from './SettingsHub';

export default SettingsHub;
